module.exports = new __parcel__URL__("shop_administrative_button.876f7b16.png").toString();